import axios from "../../plugins/FinanceiroInterceptor";

export const actions = {

    upload(context, payload) {
        const account = JSON.parse(localStorage.getItem('account'));

        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('arquivo', payload.file);
            formData.append('controle_id', payload.controle_id);
            formData.append('referencia', payload.referencia);
            formData.append('usuario', account.name);

            axios.post('carga-descontos/payload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    listar(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('carga-descontos' + payload)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    criar(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('carga-descontos', payload)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    atualizar(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('carga-descontos/' + payload.id, payload)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    detalhar(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('carga-descontos/' + payload.id + '/detalhar-descontos', payload)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    selecionarEmMassa(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('carga-descontos/selecionar-todos', payload)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    contadorSelecionados(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('carga-descontos/selecionados?' + 'referencia=' + payload.referencia)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    selecionarDesconto(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('carga-descontos/' + payload.id + '/selecionar-desconto', payload)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    excluirDescontosSelecionados(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('carga-descontos/excluir-selecionados?' + 'referencia=' + payload.referencia + '&selecionado=' + payload.selecionado)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/controle-desconto-extraordinario.js